module.exports = __webpack_public_path__ + "static/banner-aac7093914b9ac9bf1bde98deb205ed2.jpg";